module.exports = __webpack_public_path__ + "img/Comercio_Environment.4dfb332b.png";